import React, { useEffect, useState, useRef, useMemo } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

//COMMON
import Header from "components/Header";
import Footer from "components/Footer";
import Error from "components/Error";

import Main from "pages/main/Main";
import LeftNav from "components/LeftMenu";
import { getDocumentTitleByPath, getFlatMenu, URL } from "pages/menu";
import { checkLogin, setLoginAlert } from "api/restUtil";
import Loading from "components/Loading";
import Login from "pages/login/Login";


const usePrevLocation = (location) => {
	const prevLocRef = useRef(location);
	useEffect(() => {
		prevLocRef.current = location;
	}, [location]);
	return prevLocRef.current;
};

const useDocumentTitle = (title) => {
	useEffect(() => {
		const defaultTitle = document.title; // 현재 기본 제목 저장
		if(title) document.title = title;
		return () => {
			document.title = defaultTitle;
		}
	}, [title]);
}

const RootRoutes = () => {
	useEffect(() => {
		// 팝업에서 로그인 만료 시 부모창 처리용
		window.goToLogin = () => {
			navigate(URL.LOGIN);
		}
	}, []);

	//useLocation객체를 이용하여 에러페이시 이동 전 location 객체를 저장하는 코드 추가(아래 2줄) */}
	const location = useLocation();
	const prevLocation = usePrevLocation(location);

	const [mounted, setMounted] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		// setMounted(false);
		// 페이지 변경 시 로그인 체크
		if(location.pathname !== URL.LOGIN) {	// 로그인 페이지는 체크 안함.
			// 로그인 체크 (로그인 페이지는 제외)
			let isFailAlert = true;
			if(location.pathname === URL.MAIN) isFailAlert = false;	// 메인 페이지는 alert없이 페이지 이동.
			checkLogin(isFailAlert)
			.then(result => {
				if(result === "login_req"){	// 로그인 만료
					setMounted(false);
					if(window.opener) {
						// 팝업일때는 부모창 로그인 이동 및 창닫기
						window.opener.goToLogin();
						window.close();
						
					} else {
						// 팝업이 아닐때 로그인 페이지 이동.
						navigate(URL.LOGIN);
					}
				} else if(result.respCode === "SUCCESS") {
					setMounted(true);
					setLoginAlert();	// 페이지 이동시 로그인 Alert을 다시 설정.
				}
				
			})
		} else {
			setMounted(true);
		}
	}, [location]);
	
	if (mounted) {

		// 인증 없이 시스템관리 URL로 접근할 때 렌더링 되는 것을 방지하는 조건추가.
		return (
			<>
				<Loading />
				<Routes>
					{/* 에러페지시 호출시 이전 prevUrl객체를 전송하는 코드 추가(아래) */}
					<Route path={"/error"} element={<Error prevUrl={prevLocation} />} />

					<Route path="*" element={<SecondRoutes />} />
					
				</Routes>
			</>
		);
	}
};

const SecondRoutes = () => {
	const [loginVO, setLoginVO] = useState({});

	const location = useLocation();
	useDocumentTitle(getDocumentTitleByPath(location.pathname))
	
	return (
		<>
			<Header loginUser={loginVO} onChangeLogin={(user) => setLoginVO(user)} />
			<Routes>
				{/* MAIN */}
				<Route path={URL.MAIN} element={<Main />} />

				{/* LOGIN - URL : /login */}
				<Route path={URL.LOGIN} element={<Login onChangeLogin={(user) => setLoginVO(user)} />} />

				{/* ERROR */}
				<Route path={URL.ERROR} element={<Error />} />

				<Route path="*" element={<ThirdRoutes />} />
			</Routes>
			{/* <Footer /> */}
		</>
	);
};

const ThirdRoutes = () => {
	const menuItems = useMemo(() => [...getFlatMenu()], []);

	// const location = useLocation();
	// const menuItem = menuItems.find(m => m.menuUrl === location.pathname);
	// useDocumentTitle(getDocumentTitle(menuItem.title ?? menuItem.label));
	return (
		<>
			<div className="egov-container T_MAIN">
				<div className="c_wrap">
					<div className="colbox">
						<div className="left_col">
							<LeftNav />
						</div>

						<div className="right_col">
							<Routes>
								{menuItems.length > 0 && menuItems.map(menuItem =>(
									<Route key={menuItem.menuId} path={menuItem.menuUrl} element={menuItem.component} />
								))}
							</Routes>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default RootRoutes;